// extracted by mini-css-extract-plugin
export default {"productCarousel":"E0-z"};